export default __webpack_public_path__ + "static/media/man-icon.e8ac51ee.png";